<template>
<div class="chapter">
<div class="inner_page">
<h1 class="cn">Table of Contents</h1>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_titl1">Title</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_copy">Copyright</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_dedi1">Dedication</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_ackn1">Acknowledgments</a></p>
<p class="toc-entry-1"><a href="#/xhtml/Unincorporated_part1">PART ONE</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap1">Chapter 1: Calm Before the Storm</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap2">Chapter 2: Corporate Core</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap3">Chapter 3: Sebastian Front and Center</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap4">Chapter 4: Tragedy on Mars</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap5">Chapter 5: Battle of the Rocks</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap6">Chapter 6: The New Road</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap7">Chapter 7: At the Martian Gates</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap8">Chapter 8: Bowels of the Belt</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap9">Chapter 9: The Fall</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap10">Chapter 10: Commitments</a></p>
<p class="toc-entry-1"><a href="#/xhtml/Unincorporated_part2">PART TWO</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap11">Chapter 11: A Sad Affair</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap12">Chapter 12: No Choice</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap13">Chapter 13: Mind Games</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap14">Chapter 14: Deals Made in the Night</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_chap15">Chapter 15: Good-byes</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_appe1">Epilogue I</a></p>
<p class="toc-entry"><a href="#/xhtml/Unincorporated_appe2">Epilogue II</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0076e33a